var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('guest-card',[_c('login-form',{attrs:{"is-under":_vm.isUnder,"isCompany":_vm.isCompany === true ? _vm.isCompany : _vm.isStudent === true ? !_vm.isStudent : true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }